
import { defineComponent } from "vue";
import Call from "../components/landingpageCirculo/Call.vue";
import LandingPageCirculoSection from "../components/landingpageCirculo/LandingPageCirculoSection.vue";
import AboutView from "../components/landingpageCirculo/About.vue";
import DivisorView from "../components/landingpageCirculo/Divisor.vue";
import HighLightsView from "../components/landingpageCirculo/HighLights.vue";
import Footer from "../components/application/moldure/Footer.vue";

export default defineComponent({
  name: "LandingPageCirculo",
  components: {
    Footer,
    HighLightsView,
    DivisorView,
    AboutView,
    LandingPageCirculoSection,
    Call
  },

  setup() {
    return {};
  }
});
